const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子', heat: '98.6万', trend: 'up', icon: 'ri-arrow-up-line' },
  { rank: 2, title: '某女团成员合约纠纷升级始末', heat: '87.3万', trend: 'up', icon: 'ri-arrow-up-line' },
  { rank: 3, title: '知名导演片场争吵事件全记录', heat: '72.1万', trend: 'up', icon: 'ri-arrow-up-line' },
  { rank: 4, title: '网红直播卖假货翻车现场', heat: '65.8万', trend: 'down', icon: 'ri-arrow-down-line' },
  { rank: 5, title: '男演员被前女友实名爆料家暴', heat: '59.4万', trend: 'up', icon: 'ri-arrow-up-line' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">吃瓜热度榜</h2>
              <p className="text-sm text-foreground-600 mt-1">今日最热关注排行</p>
            </div>
            <span className="text-xs text-foreground-500">实时更新</span>
          </div>

          <div className="space-y-3">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all cursor-pointer group"
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-black text-sm ${
                  i < 3 ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <div className={`w-5 h-5 flex items-center justify-center ${
                    item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'
                  }`}>
                    <i className={`${item.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <span className="text-xs font-bold text-foreground-700 whitespace-nowrap">{item.heat}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}